import styled, { createGlobalStyle } from 'styled-components'
import { backgroundOrange, blackOrange, darkOrange, orange, white } from '@/theme/colors'

export const Wrapper = styled.div`
    width: 100%;

    .react-datepicker-wrapper {
        width: 100%;
    }

    .react-datepicker__input-container input {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        font-size: 14px;
        background: ${white};
        color: ${blackOrange};
        transition: border-color 0.2s, box-shadow 0.2s;
        cursor: pointer;

        &:focus {
            outline: none;
            border-color: ${orange};
            box-shadow: 0 0 0 3px rgba(209, 95, 42, 0.15);
        }

        &::placeholder {
            color: #9ca3af;
        }
    }
`

export const DatePickerGlobalStyles = createGlobalStyle`
    .react-datepicker {
        font-family: inherit;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        overflow: hidden;
    }

    .react-datepicker__header {
        background: ${backgroundOrange};
        border-bottom: 1px solid #f3e7e2;
        padding-top: 12px;
    }

    .react-datepicker__current-month,
    .react-datepicker-time__header {
        color: ${blackOrange};
        font-weight: 600;
        font-size: 14px;
    }

    .react-datepicker__day-name {
        color: ${darkOrange};
        font-weight: 500;
    }

    .react-datepicker__day {
        color: ${blackOrange};
        border-radius: 6px;

        &:hover {
            background: ${backgroundOrange};
        }
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--keyboard-selected {
        background: ${orange};
        color: ${white};

        &:hover {
            background: ${darkOrange};
        }
    }

    .react-datepicker__day--today {
        font-weight: 700;
        color: ${darkOrange};
    }

    .react-datepicker__day--disabled {
        color: #d1d5db;
    }

    .react-datepicker__navigation-icon::before {
        border-color: ${darkOrange};
    }

    .react-datepicker__time-container {
        border-left: 1px solid #f3e7e2;
    }

    .react-datepicker__time-list-item--selected {
        background: ${orange} !important;
        color: ${white} !important;
    }

    .react-datepicker__time-list-item:hover {
        background: ${backgroundOrange} !important;
    }

    .react-datepicker__triangle {
        display: none;
    }
`
